const axios = require("axios");

import router from "../router/router.js";

const state = { isAuthenticated: false };

const getters = {
  hasAccess(state) {
    return state.isAuthenticated;
  }
};

const actions = {

  authenticate: (context) => axios.
    get(
      "/api/version",
      { headers: { "Cache-Control": "no-cache" } }
    ).
    then(() => context.commit("setAuth")).
    catch(() => { }),


  logOut: (context) => {
    document.cookie = `sitePass=;path=/;domain=.thinxtra.com;
expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    context.commit("resetAuth");
    return router.push({ name: "login" });
  }

};

const mutations = {
  setAuth: (state) => {
    state.isAuthenticated = true;
  },
  resetAuth: (state) => {
    state.isAuthenticated = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/authentication.js